import React, {Fragment, type ReactNode, useEffect, useRef} from "react";

import type {IInfiniteList} from "../hooks/use_infinite_list";
import {ListLoader} from "./ListLoader";
import {NoMoreItems} from "./NoMoreItems";

export interface IInfiniteScrollListProps<ListItemValue> {
    infiniteList: IInfiniteList<ListItemValue>;
    listComponent: React.FC<IInfiniteScrollListWrapProps>;
    itemComponent: React.FC<IInfiniteScrollItemProps<ListItemValue>>;
    handleIsIntersecting: (isIntersecting: boolean) => void;
    loader?: ReactNode;
    emptyListInfo?: ReactNode;
    listIntersectionContainerId?: string;
}

export interface IInfiniteScrollListWrapProps {
    children: ReactNode;
}

export interface IInfiniteScrollItemProps<ListItemValue> {
    item: ListItemValue;
    index: number;
}

export const InfiniteScrollList = <ListItemValue,>(props: IInfiniteScrollListProps<ListItemValue>) => {
    const {infiniteList, listComponent: ListComponent, itemComponent, handleIsIntersecting, loader, emptyListInfo, listIntersectionContainerId} = props;

    const listFooter = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!listFooter.current) {
            return;
        }

        const option = {
            root: listIntersectionContainerId ? document.getElementById(listIntersectionContainerId) : null,
            rootMargin: "30px",
            threshold: 0
        };

        const observer = new IntersectionObserver(([e]) => {
            handleIsIntersecting(e.isIntersecting);
        }, option);

        observer.observe(listFooter.current);

        return () => {
            if (!listFooter.current) {
                return;
            }

            observer.unobserve(listFooter.current);
        };
    }, [listIntersectionContainerId]);

    const fullListIsLoadedButNoItems = !infiniteList.canLoadMore && infiniteList.items.length === 0;

    return (
        <>
            <ListComponent>
                {infiniteList.items.map((item, i) => (
                    <Fragment key={`ili${i}`}>{itemComponent({item: item.data, index: i}) as ReactNode}</Fragment>
                ))}
            </ListComponent>

            <div ref={listFooter}>
                {infiniteList.canLoadMore && loader}
                {infiniteList.canLoadMore && !loader && <ListLoader />}
                {fullListIsLoadedButNoItems && emptyListInfo}
                {fullListIsLoadedButNoItems && !emptyListInfo && <NoMoreItems />}
            </div>
        </>
    );
};
import React, {Fragment, type ReactNode, useEffect, useRef} from "react";

import type {IInfiniteList} from "../hooks/use_infinite_list";
import {ListLoader} from "./ListLoader";
import {NoMoreItems} from "./NoMoreItems";

export interface IInfiniteScrollListProps<ListItemValue> {
    infiniteList: IInfiniteList<ListItemValue>;
    listComponent: React.FC<IInfiniteScrollListWrapProps>;
    itemComponent: React.FC<IInfiniteScrollItemProps<ListItemValue>>;
    handleIsIntersecting: (isIntersecting: boolean) => void;
    loader?: ReactNode;
    emptyListInfo?: ReactNode;
    listIntersectionContainerId?: string;
}

export interface IInfiniteScrollListWrapProps {
    children: ReactNode;
}

export interface IInfiniteScrollItemProps<ListItemValue> {
    item: ListItemValue;
    index: number;
}

export const InfiniteScrollList = <ListItemValue,>(props: IInfiniteScrollListProps<ListItemValue>) => {
    const {infiniteList, listComponent: ListComponent, itemComponent, handleIsIntersecting, loader, emptyListInfo, listIntersectionContainerId} = props;

    const listFooter = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!listFooter.current) {
            return;
        }

        const option = {
            root: listIntersectionContainerId ? document.getElementById(listIntersectionContainerId) : null,
            rootMargin: "30px",
            threshold: 0
        };

        const observer = new IntersectionObserver(([e]) => {
            handleIsIntersecting(e.isIntersecting);
        }, option);

        observer.observe(listFooter.current);

        return () => {
            if (!listFooter.current) {
                return;
            }

            observer.unobserve(listFooter.current);
        };
    }, [listIntersectionContainerId]);

    const fullListIsLoadedButNoItems = !infiniteList.canLoadMore && infiniteList.items.length === 0;

    return (
        <>
            <ListComponent>
                {infiniteList.items.map((item, i) => (
                    <Fragment key={`ili${i}`}>{itemComponent({item: item.data, index: i}) as ReactNode}</Fragment>
                ))}
            </ListComponent>

            <div ref={listFooter}>
                {infiniteList.canLoadMore && loader}
                {infiniteList.canLoadMore && !loader && <ListLoader />}
                {fullListIsLoadedButNoItems && emptyListInfo}
                {fullListIsLoadedButNoItems && !emptyListInfo && <NoMoreItems />}
            </div>
        </>
    );
};
